// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2BlIF","footer":"ModalUpdate_footer__3td1w"};